import {
  styled,
  StyledEngineProvider,
  ThemeProvider,
  lighten,
} from '@mui/material/styles';
import React, { useEffect, useState } from 'react';
import EmojiReactions from '../EmojiReactions';
import Header from './Header';
import Reactions from './Reactions';
import MessageContent from './MessageContent';
import { COLORS } from 'constants/theme';
import CssBaseline from '@mui/material/ScopedCssBaseline';
import getTheme from 'modules/connect-card-widget/utils/getTheme';
import Box from '@mui/material/Box';

const Root = styled('div')`
  max-width: 720px;
  margin: auto;
  header {
    text-align: center;
    margin-bottom: 24px;
    .logo {
      max-width: 140px;
      max-height: 80px;
    }
  }
  .fab {
    position: fixed;
    bottom: 20px;
    right: 20px;
  }
`;

const MessageView = ({
  isPreview,
  message,
  onReaction,
  account,
  children,
  containerStyle,
  onCTAClick,
}) => {
  const [emojiReactionsVisible, setEmojiReactionsVisible] = useState();
  const brand = isPreview ? account.account_brand : message.account_brand;
  const accountColor = isPreview
    ? account.account_color
    : message.account_color;
  const primaryColor =
    message.primary_color || accountColor || COLORS[brand.toUpperCase()];

  const theme = getTheme({
    primary: primaryColor,
    text: message.text_color,
  });

  useEffect(() => {
    if (emojiReactionsVisible) {
      const timer = setTimeout(() => {
        setEmojiReactionsVisible(false);
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [emojiReactionsVisible]);

  const handleReaction = (emoji) => {
    setEmojiReactionsVisible(emoji);
    onReaction(emoji);
  };

  return (
    <>
      {emojiReactionsVisible && (
        <EmojiReactions emojiName={emojiReactionsVisible} />
      )}
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <CssBaseline
            sx={{
              borderRadius: isPreview && 3,
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: -70,
                right: -70,
                height: '50%',
                backgroundColor: lighten(theme.palette.primary.main, 0.6),
                borderBottomLeftRadius: '200%',
                borderBottomRightRadius: '200%',
                boxShadow: `rgba(0,0,0,.1) 0 0 10px 0px`,
              }}
            />
            <Box
              sx={{
                py: 6,
                px: 2,
                position: 'relative',
                zIndex: 1,
              }}
            >
              <Root sx={containerStyle}>
                <Header
                  logoPath={
                    isPreview
                      ? message.logo?.location || account.account_logo_url
                      : message.logo?.location
                  }
                  fallbackLogoUrl={message.account_logo_url}
                  accountName={
                    isPreview ? account.account_name : message.account_name
                  }
                  heading={message.headline}
                />
                <MessageContent message={message} onCTAClick={onCTAClick} />
                <Reactions message={message} onReaction={handleReaction} />
                {children}
              </Root>
            </Box>
          </CssBaseline>
        </ThemeProvider>
      </StyledEngineProvider>
    </>
  );
};

export default MessageView;
